import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Header from './components/Header';
import AuthForm from './components/AuthForm'; 
import ChatContainer from './components/ChatContainer';
import AdminDashboard from './admin/AdminDashboard';
import ForgottenPassword from './components/ForgottenPassword';
import ResetPassword from './components/ResetPassword'; 

// --- LE LAYOUT QUI GÈRE LA SÉCURITÉ ET LE CHARGEMENT ---
const AuthenticatedLayout = ({ children }) => {
    // 👇 1. ON RÉCUPÈRE LA FONCTION LOGOUT ICI
    const { authToken, loading, logout } = useAuth(); 
    const [historyOpen, setHistoryOpen] = useState(true);

    // 1. CHARGEMENT
    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center bg-[#f4f6f8]">
                <div className="flex flex-col items-center gap-4">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#Ceaa5b]"></div>
                    <p className="text-[#1c2143] font-medium animate-pulse">Chargement de SophIA...</p>
                </div>
            </div>
        );
    }

    // 2. SÉCURITÉ
    if (!authToken || !authToken.token) { 
        return <Navigate to="/login" />;
    }

    // 3. APPLICATION
    return (
        <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
            <Header 
                authToken={authToken} 
                handleLogout={logout} // 👈 2. ON LA PASSE AU HEADER ICI
                toggleHistory={() => setHistoryOpen(!historyOpen)} 
            />
            <div className="flex-1 overflow-hidden relative">
                {React.cloneElement(children, { historyOpen, setHistoryOpen })}
            </div>
        </div>
    );
};

function App() {
    return (
        <AuthProvider>
            <Routes>
                {/* Routes Publiques */}
                <Route path="/login" element={<AuthForm />} />
                <Route path="/forgot-password" element={<ForgottenPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                
                {/* Routes Privées (Chat) */}
                <Route path="/" element={
                    <AuthenticatedLayout>
                        <ChatContainer />
                    </AuthenticatedLayout>
                } />

                {/* Routes Privées (Admin) */}
                <Route path="/admin/*" element={
                    <AuthenticatedLayout>
                        <AdminDashboard />
                    </AuthenticatedLayout>
                } />
            </Routes>
        </AuthProvider>
    );
}

export default App;